import { KeyValue } from "@/main/models/common";

export enum StatusRegisterTypes {
	GET_STATUS_REGISTER = "@statusRegister/GET_STATUS_REGISTER",
	SAVE_STATUS_REGISTER = "@statusRegister/SAVE_STATUS_REGISTER",
	RESET_REDUCER_STATUS_REGISTER = "@statusRegister/RESET_REDUCER_STATUS_REGISTER",
}

export interface StatusRegisterState {
	readonly statusRegister: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetStatusRegister {
	type: typeof StatusRegisterTypes.GET_STATUS_REGISTER;
	payload: {
		showPending: boolean;
	};
}

export interface SaveStatusRegister {
	type: typeof StatusRegisterTypes.SAVE_STATUS_REGISTER;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerStatusRegister {
	type: typeof StatusRegisterTypes.RESET_REDUCER_STATUS_REGISTER;
}

export type StatusRegisterActionTypes = GetStatusRegister | SaveStatusRegister | ResetReducerStatusRegister;
